module.exports = __webpack_public_path__ + "static/media/second_bg.a4d2ac90.mp4";